import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { API_URL } from '../../constant';
import './CaptainTCCardAgent.css';
import fivePoundCardImg from '../../images/captain-tc/5PoundCard.jpg';
import tenPoundCardImg from '../../images/captain-tc/10PoundCard.jpg';
import twentyFivePoundCardImg from '../../images/captain-tc/25PoundCard.jpg';
import wallet2 from "../../images/shapes/Wallet03.1 1.png";
import oldbank from "../../images/shapes/bank-pound-icon2 4.png";
import promoTopCoinIcon from "../../images/shapes/tc-units-wallet 2.png";
import promoCashIcon from "../../images/shapes/tc-cash-wallet 1.png";

function CaptainTCCardAgent() {
    const outletContext = useOutletContext() || {};
    const { userData } = outletContext;

    const [loading, setLoading] = useState(true);
    const [cards, setCards] = useState([
        { tier: '£5', price: '£ 5.00', owned: false, serial: null, image: fivePoundCardImg },
        { tier: '£10', price: '£ 10.00', owned: false, serial: null, image: tenPoundCardImg },
        { tier: '£25', price: '£ 25.00', owned: false, serial: null, image: twentyFivePoundCardImg },
    ]);

    // Sales history
    const [salesHistory, setSalesHistory] = useState([]);
    const [salesLoading, setSalesLoading] = useState(false);

    // Agent TopCoin Wallet
    const [agentWalletBalance, setAgentWalletBalance] = useState(0);

    // Promo wallet balances
    const [extraCardBalance, setExtraCardBalance] = useState(0);
    const [bonusCardBalance, setBonusCardBalance] = useState(0);

    const getAuthHeaders = useCallback(() => {
        const token = localStorage.getItem('auth_token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
    }, []);

    const fetchCardStatus = useCallback(async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('auth_token');
            if (!token) return;

            const response = await fetch(`${API_URL}/api/agent/captain-tc-cards`, {
                headers: getAuthHeaders(),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success && data.cards) {
                    setCards(prev => prev.map(card => {
                        const apiCard = data.cards.find(c =>
                            c.tier === card.tier || c.price === card.price
                        );
                        if (apiCard) {
                            return {
                                ...card,
                                owned: apiCard.owned || false,
                                serial: apiCard.serial || null,
                            };
                        }
                        return card;
                    }));
                }
                // Set promo wallet balances
                if (data.promo_wallet) {
                    setExtraCardBalance(data.promo_wallet.extra_card_balance || 0);
                    // setBonusCardBalance(data.promo_wallet.bonus_card_balance || 0);
                    setBonusCardBalance(0);
                }
            }
        } catch (err) {
            console.warn('Captain TC Cards Agent API not available:', err.message);
        } finally {
            setLoading(false);
        }
    }, [getAuthHeaders]);

    const fetchSalesHistory = useCallback(async () => {
        try {
            setSalesLoading(true);
            const token = localStorage.getItem('auth_token');
            if (!token) return;

            const response = await fetch(`${API_URL}/api/agent/captain-tc-cards/sales-history`, {
                headers: getAuthHeaders(),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    setSalesHistory(data.sales || []);
                    setAgentWalletBalance(data.agent_wallet_balance || 0);
                }
            }
        } catch (err) {
            console.warn('Sales history API not available:', err.message);
        } finally {
            setSalesLoading(false);
        }
    }, [getAuthHeaders]);

    const handleBuy = async (card) => {
        if (card.owned) return;
        if (!window.confirm(`Do you want to buy this card (${card.tier})?`)) return;

        try {
            setLoading(true);
            const token = localStorage.getItem('auth_token');
            const tierValue = parseInt(card.tier.replace('£', ''), 10);
            
            const response = await fetch(`${API_URL}/api/agent/captain-tc-cards/buy`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify({ tier: tierValue })
            });

            const data = await response.json();
            if (response.ok && data.success) {
                alert('Card purchased successfully!');
                await fetchCardStatus(); // Refresh cards
            } else {
                alert(data.message || 'Failed to purchase card.');
            }
        } catch (err) {
            console.error('Error buying card:', err);
            alert('An error occurred during purchase.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCardStatus();
        fetchSalesHistory();
    }, [fetchCardStatus, fetchSalesHistory]);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        } catch {
            return dateString;
        }
    };

    if (loading) {
        return (
            <div className="captain-tc-agent-wrapper">
                <div className="captain-tc-agent-loading">
                    <div className="captain-tc-agent-spinner"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="captain-tc-agent-wrapper">
            {/* Header */}
            <div className="captain-tc-agent-header">
                <div className="captain-tc-agent-header-left">
                    <span className="captain-tc-agent-label">Captain TC</span>
                    <h2 className="captain-tc-agent-title">Cash-Wallet Card</h2>
                </div>
                {/* <div className="captain-tc-agent-header-right">
                    <img
                        src={captainTcImg}
                        alt="Captain TC Card"
                        className="captain-tc-agent-thumb"
                    />
                </div> */}
            </div>

            {/* Card Tiers - Owned Status */}
            <div className="captain-tc-agent-cards-grid">
                {cards.map((card) => (
                    <div 
                        key={card.tier} 
                        className={`captain-tc-agent-card-item ${card.owned ? '' : 'cursor-pointer'}`}
                        onClick={() => handleBuy(card)}
                        style={{ cursor: card.owned ? 'default' : 'pointer' }}
                    >
                        {/* Owned Header */}
                        <div className="captain-tc-agent-card-owned">
                            Owned: <span className={card.owned ? 'owned-yes' : 'owned-no'}>
                                {card.owned ? 'Yes' : 'No'}
                            </span>
                        </div>

                        {/* Visual Card */}
                        <div className="captain-tc-agent-card-body">
                            <img src={card.image} alt={`${card.tier} Captain TC Card`} className="captain-tc-actual-card-img" />
                        </div>

                        {/* Serial Footer */}
                        <div className="captain-tc-agent-card-serial">
                            {card.owned && card.serial ? (
                                <span>Serial : <strong>{card.serial}</strong></span>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* New Promo Wallets Section */}
            <div className="captain-tc-agent-wallet-section" style={{ marginBottom: '32px' }}>
                <div className="captain-tc-agent-wallet-row">
                    <div className="captain-tc-agent-wallet-info">
                        <div className="captain-tc-agent-wallet-icon">
                            <img src={promoTopCoinIcon} alt="TopCoin Promo Wallet" style={{ backgroundColor: "white" }} />
                        </div>
                        <div>
                            <h4 className="captain-tc-agent-wallet-title">Captain TC Promotion TopCoin</h4>
                            <span className="captain-tc-agent-wallet-balance">
                                {extraCardBalance.toLocaleString()} TC
                            </span>
                        </div>
                    </div>
                </div>

                <div className="captain-tc-agent-wallet-row">
                    <div className="captain-tc-agent-wallet-info">
                        <div className="captain-tc-agent-wallet-icon">
                            <img src={promoCashIcon} alt="Cash Promo Wallet" style={{ backgroundColor: "white" }} />
                        </div>
                        <div>
                            <h4 className="captain-tc-agent-wallet-title">Captain TC Promotional Cash Wallet</h4>
                            <span className="captain-tc-agent-wallet-balance">
                                £ {(bonusCardBalance * 0.005).toFixed(2)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Sales History Section */}
            <div className="captain-tc-agent-sales-section">
                <h3 className="captain-tc-agent-sales-title">
                    The TopCoin Reward Promotion
                    <span className="captain-tc-agent-sales-subtitle">
                        (As the Agent Sells the Cards to the Customer)
                    </span>
                </h3>

                <div className="captain-tc-agent-table-container">
                    <table className="captain-tc-agent-table">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Serial</th>
                                <th>Price</th>
                                <th>Date</th>
                                <th>TopCoin Earned</th>
                                <th>History</th>
                            </tr>
                        </thead>
                        <tbody>
                            {salesHistory.length > 0 ? (
                                salesHistory.map((sale, index) => (
                                    <tr key={sale.id || index}>
                                        <td>{index + 1}</td>
                                        <td className="serial-cell">{sale.serial || '—'}</td>
                                        <td>{sale.price || '—'}</td>
                                        <td>{formatDate(sale.date)}</td>
                                        <td className="topcoin-cell">
                                            {sale.topcoin_earned
                                                ? sale.topcoin_earned.toLocaleString()
                                                : '—'}
                                        </td>
                                        <td>
                                            <button
                                                className="captain-tc-agent-history-btn"
                                                disabled={!sale.serial}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <>
                                    {[1, 2, 3, 4].map((n) => (
                                        <tr key={n} className="empty-row">
                                            <td>{n}</td>
                                            <td>—</td>
                                            <td>—</td>
                                            <td>—</td>
                                            <td>—</td>
                                            <td>—</td>
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Agent TopCoin Wallet */}
            <div className="captain-tc-agent-wallet-section">
                <div className="captain-tc-agent-wallet-row">
                    <div className="captain-tc-agent-wallet-info">
                        <div className="captain-tc-agent-wallet-icon">
                            <img src={wallet2} alt="Wallet" style={{ backgroundColor: "white" }} />
                        </div>
                        <div>
                            <h4 className="captain-tc-agent-wallet-title">Advertising Agent TopCoin Wallet</h4>
                            <span className="captain-tc-agent-wallet-balance">
                                {agentWalletBalance.toLocaleString()} TC
                            </span>
                        </div>
                    </div>
                </div>

                <div className="captain-tc-agent-withdraw-row">
                    <div className="captain-tc-agent-withdraw-info">
                        <div className="captain-tc-agent-withdraw-icon">
                            <img src={oldbank} alt="Bank" style={{ backgroundColor: "white" }} />
                        </div>
                        <h4 className="captain-tc-agent-withdraw-title">Withdrawal</h4>
                    </div>
                    <button className="captain-tc-agent-withdraw-btn" disabled>
                        Withdraw
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CaptainTCCardAgent;
